module.exports = __webpack_public_path__ + "static/login_screen-78bc24def985f7b0eb1e11b93e071d07.png";